import { gql } from '@apollo/client';
const GET_SPECIFICATION_COMPONENT_CARDS = gql `
  query GetSpecificationComponentCards($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        components {
          edges {
            node {
              id
              name
              productSnapshot {
                id
                product {
                  id
                  name
                  status
                  pictures(first: 1) {
                    edges {
                      node {
                        id
                        image
                      }
                    }
                  }
                  supplier {
                    id
                    shortName
                    fullName
                  }
                  producerCode {
                    id
                    name
                  }
                  category {
                    id
                    type
                    typeLabelPL
                    typeLabelEN
                  }
                  activeProductVariantsCount
                }
              }
              productCategory {
                id
                type
                typeLabelPL
                typeLabelEN
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_COMPONENT_CARDS;
